module.exports = __webpack_public_path__ + "media/images/undraw/shift/chat_bot-1021393d73540762afce052e778e350f.png";